module.exports = __webpack_public_path__ + "static/media/render.1c272085.png";